module.exports = __webpack_public_path__ + "img/541.0db09138.jpg";